import React from 'react';
import { SupportInstance } from '../types/SupportTypes';

interface SupportInstanceSelectorProps {
  instances: SupportInstance[];
  selectedCustomerIntegrationId: number | null;
  onSelectInstance: (customerIntegrationId: number) => void;
}

// Support Instance Selector Component
const SupportInstanceSelector: React.FC<SupportInstanceSelectorProps> = ({ 
  instances, 
  selectedCustomerIntegrationId, 
  onSelectInstance 
}) => {
  if (!instances || instances.length === 0) {
    return (
      <div style={{ marginBottom: '1.5rem', color: '#999' }}>
        No instances available
      </div>
    );
  }

  return (
    <div style={{ 
      marginBottom: '1.5rem',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem'
    }}>
      <label htmlFor="instance-select" style={{ fontWeight: 500 }}>Instance:</label>
      <select
        id="instance-select"
        value={selectedCustomerIntegrationId || ''}
        onChange={(e) => onSelectInstance(Number(e.target.value))}
        style={{
          padding: '0.5rem',
          borderRadius: '0.25rem',
          border: '1px solid #e0e0e0',
          backgroundColor: '#fff',
          minWidth: '200px',
          fontSize: '0.9rem'
        }}
      >
        {instances.map((instance) => (
          <option key={instance.customerIntegrationId} value={instance.customerIntegrationId}>
            {instance.instanceName}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SupportInstanceSelector;
